import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const OpenFaresWidget = () => {
  const location = useLocation();

  useEffect(() => {
    if (window.__openfaresReady) return;

    window.__openfaresReady = new Promise((resolve) => {
      const script = document.createElement("script");
      script.src =
        "https://maharaja-of.be.openfares.com/scripts/b2c.js?key=bdb13b66-af5e-41e5-be4a-1d907219fe74&target=ofEngine";
      script.async = true;

      script.onload = () => {
        resolve();
      };

      document.body.appendChild(script);
    });
  }, []);

  useEffect(() => {
    if (location.pathname.startsWith("/flights")) {
      const alreadyReloaded = sessionStorage.getItem("flights_reloaded");

      if (!alreadyReloaded) {
        sessionStorage.setItem("flights_reloaded", "yes");
        window.location.reload();
      }
    } else {
      // reset when leaving flights so next visit reloads again
      sessionStorage.removeItem("flights_reloaded");
    }
  }, [location.pathname]);

  return null;
};

export default OpenFaresWidget;
